import {
    MobileProfileLastDepositProviderInfoStyled,
    MobileProfileLastDepositRepeatButtonStyled,
    MobileProfileLastDepositStyled,
    MobileProfileLastDepositTitleStyled
} from "./styled/MobileProfileLastDepositStyled";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { Button } from "react-bootstrap";
import { BinIcon } from "../../../components/icon/Icon";
import PaymentMethodLogo from "../../../modules/Account/components/PaymentMethodLogo/PaymentMethodLogo";
import { useDispatch, useSelector } from "react-redux";
import { getPayoutLastDeposit } from "../../../modules/Account/accountSelectors";
import amountFormat from "../../../utils/amountFormat";
import { useCallback } from "react";
import { openMobileSliderPageAction } from "../../mobileAppActions";
import { MOBILE_SLIDER_PAGES_IDS } from "../MobileSliderPages/mobileSliderPagesConstants";
import _ from "lodash";

function MobileProfileLastDeposit() {
    const {getLangPath} = useLangContext();

    const dispatch = useDispatch();
    const lastDeposit = useSelector(getPayoutLastDeposit);

    const handleRepeatButtonClick = useCallback(() => {
        dispatch(openMobileSliderPageAction({
            name: MOBILE_SLIDER_PAGES_IDS.DEPOSIT,
            amount: _.round(lastDeposit.amount, 2),
            payment_id: lastDeposit.payment_id,
        }));
    }, [dispatch, lastDeposit]);

    return <MobileProfileLastDepositStyled>
        <div>
            <MobileProfileLastDepositTitleStyled>
                {getLangPath('deposit.last_top_up')}
            </MobileProfileLastDepositTitleStyled>
            <MobileProfileLastDepositProviderInfoStyled>
                <PaymentMethodLogo paymentName={lastDeposit?.payment_name}/>
                <span>${amountFormat(lastDeposit.amount, 2)}</span>
            </MobileProfileLastDepositProviderInfoStyled>
        </div>
        <Button variant={'info'} as={MobileProfileLastDepositRepeatButtonStyled} onClick={handleRepeatButtonClick}>
            <span>{getLangPath('deposit.repeat')}</span>
            <BinIcon name={'IcRefresh'} className={'ms-2'}/>
        </Button>
    </MobileProfileLastDepositStyled>
}

export default MobileProfileLastDeposit;
